export const life = {
  mounted(){
    this.methods('loadTabs');
    this.methods('updateTabs');
    this.methods('checkClosable');
  },
};
export const event = {
  // 增删tabs
  handleTabsEdit(targetName,action){
    // console.log('tab增删:',targetName,action);
    if(action === 'remove'){
      this.methods('removeTab',targetName);
      this.methods('checkClosable');
    }
  },
  // 鼠标中键删除
  removeTabByMiddle(route){
    if(this.closable){
      this.methods('removeTab',route);
      this.methods('checkClosable');
    }
  },
  // 点击tab,item是被选中的标签的vue实例
  clickTab(item){
    if(this.$route.name === item.name){
      return ;
    }
    // console.log('tab切换：', item.name);
    this.$router.push({name:item.name})
  }
};
export const watch = {
  $route(){
    this.methods('loadTabs');
    this.methods('updateTabs');
    this.methods('checkClosable');
  }
};
export default {
  life, event, watch
};
